
    import {Component, Vue} from "vue-property-decorator";
    import ConfirmDialog from "../ConfirmDialog.vue";
    import {deepCopy} from "@/auxillary"
    import {MdbsCore} from "@/api/tsclient";
    import RoleEditDialog from "@/components/admin/RoleEditDialog.vue";
    import {rolesModule} from "@/store";

    @Component({
        components: {
            RoleEditDialog,
            ConfirmDialog
        },
    })
    export default class RoleTable extends Vue {
        private _loading: boolean = false;

        headers: any = [
            {text: 'Anzeigename', value: 'displayName'},
            {text: 'Kennung', value: 'identifier'},
            {text: 'Aktionen', value: 'actions', sortable: false, width: "120px", align: "center"}
        ];
        options: any = {
            sortBy: ['displayName'],
            sortDesc: [false]
        };
        search: string = "";

        itemToDelete: MdbsCore.ShortRoleDto | null = null;
        itemToEdit: MdbsCore.RoleDto | null = null;

        get roles() {
            return rolesModule.roles;
        }

        get loading() {
            return this._loading || rolesModule.isLoading;
        }

        get canCreateRole() {
            return true; //TODO Permission mgmgt
        }

        get canEditRole() {
            return true; //TODO Permission mgmgt
        }

        get canDeactivateRole() {
            return true; //TODO Permission mgmgt
        }

        async mounted() {
            await rolesModule.loadAll();
        }

        showNewDialog() {
            this.itemToEdit = new MdbsCore.UserDto();
        }

        showEditDialog(group: MdbsCore.UserDto) {
            this.itemToEdit = deepCopy(group);
        }

        showDeleteDialog(group: MdbsCore.UserDto) {
            this.itemToDelete = group;
        }

        async deleteItem() {
            // TODO disable deactivation of own current user role
            if (this.itemToDelete?.id == null)
                return
            this._loading = true;
            const idToDelete = this.itemToDelete?.id;
            this.itemToDelete = null;
            await rolesModule.deleteRole(idToDelete)
            this._loading = false;
        }

    }
